module.exports = __webpack_public_path__ + "img/payReturn.1358529c.svg";